module.exports = __webpack_public_path__ + "img/convertions.bfed9e6f.gif";